import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ScheduleResult {
    data: any[];
}

export const deleteSchedule = createAsyncThunk(
    'calendar/delete',
    async (params: { eventId: string }, { rejectWithValue }) => {
        const api_url = `${URL_API}/supplier-portal/calendar/events/${params.eventId}`;

        try {
            const { data } = await axios.delete<ScheduleResult>(api_url, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            return data;

        } catch (error) {
            // @ts-ignore
            if (error.response?.status === 401) {
                logoutAndRedirect('/sign-in')
            }

            // @ts-ignore
            return rejectWithValue(error.response?.data ?? error)
        }
    }
);
